import * as ConfigActions from './actions';

const { setKeycloakLoaded } = ConfigActions;

export { setKeycloakLoaded };
